<script lang="ts">
  import { building } from '$app/env'
  import { applyAction, enhance } from '$app/forms'
  import { invalidate } from '$app/navigation'
  import { resolve } from '$app/paths'
  import { page } from '$app/state'
  import { getLoginUrl } from '$lib/utils/general'
  import type { SubmitFunction } from '@sveltejs/kit'
  import LogoutIcon from '~icons/tabler/logout'
  import SettingsIcon from '~icons/tabler/settings'
  import ProfileCard from '../ProfileCard.svelte'
  import ProfileSkeleton from './ProfileSkeleton.svelte'

  let loading = $state(false)

  const logout: SubmitFunction = () => {
    loading = true
    return async ({ result }) => {
      if (result.type === 'redirect') {
        await invalidate('supabase:auth')
      } else {
        await applyAction(result)
      }
      loading = false
    }
  }

  let loginUrl = $derived(getLoginUrl(page.url))

  let session = $derived(page.data.session)

  const showSkeleton = building
</script>

<div class="authentication" class:loading>
  {#if showSkeleton}
    <ProfileSkeleton />
  {:else if !session}
    <!-- eslint-disable-next-line svelte/no-navigation-without-resolve -->
    <a class="@button" href={loginUrl}>Login</a>
  {:else}
    <form action="/logout" method="post" use:enhance={logout}>
      <button
        disabled={loading}
        class="unstyled link"
        type="submit"
        title="Logout"><LogoutIcon /></button
      >
    </form>
    <a class="icon-link settings" href={resolve('/settings')} title="Settings"
      ><SettingsIcon /></a
    >

    <ProfileCard profile={session.profile} showIdIfNoUsername={false} />
    {#if session && !page.url.pathname.startsWith('/session')}
      {#await import('../ActiveSessions.svelte') then c}
        <c.default />
      {/await}
    {/if}
  {/if}
</div>

<style lang="postcss">
  .authentication {
    display: flex;
    position: relative;
    flex: 1;
    justify-content: flex-end;
    align-items: center;
    gap: 1em;
    transition: opacity 0.2s ease-in-out;
    min-width: 0;
    &.loading {
      opacity: 0.2;
    }
    & .settings,
    & button,
    & :global(button) {
      flex-shrink: 0;
    }
  }
  .unstyled.link {
    color: var(--color-text);
  }
  .icon-link {
    display: grid;
    place-items: center;
    color: var(--color-text);
  }
  form {
    display: inherit;
    margin: 0;
  }
</style>
